<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-combobox
      v-if="!isMobile"
      ref="combo"
      v-model="model"
      :filter="filter"
      :hide-no-data="!search"
      :items="items"
      :search-input.sync="search"
      hide-selected
      hide-details
      :label="$t('tag')"
      :outlined="!solo"
      :solo="solo"
      :flat="solo"
      :menu-props="{maxHeight: (isMobile ? 0 : 200)}"
      multiple
      dense
      small-chips
      :background-color="(solo ? '#e5e5e5' : null)"
      @blur="$emit('blur', model)"
      @click="openMobileDialog"
    >
      <template v-slot:no-data>
        <v-list-item>
          <span class="subheading">Create</span>
          <v-chip
            :color="`${colors[nonce - 1]} lighten-3`"
            label
            small
          >
            {{ search }}
          </v-chip>
        </v-list-item>
      </template>
      <template v-slot:selection="{attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="item.color"
          :input-value="selected"
          label
          small
          class="px-1 mb-1 mt-1"
        >
          <span class="pr-2 white--text">
            {{ item.text }}
          </span>
          <v-icon
            small
            color="white"
            @click="parent.selectItem(item)"
          >
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-chip
          :color="item.color"
          dark
          label
          small
        >
          {{ item.text }}
        </v-chip>
        <v-spacer />
        <v-list-item-action
          class="d-inline"
          @click.stop
        >
          <v-btn
            icon
            small
            @click.stop.prevent="edit(index, item)"
          >
            <v-icon color="grey">
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            small
            icon
            @click.stop.prevent="openStop(item)"
          >
            <v-icon color="pink">
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-combobox>
    <v-autocomplete
      v-if="isMobile"
      v-model="mobileModel"
      clearable
      :items="mobileItems"
      no-filter
      height="38"
      item-text="text"
      item-value="id"
      :label="$t('tag')"
      :outlined="!solo"
      :solo="solo"
      :flat="solo"
      multiple
      hide-details
      :menu-props="{
        maxHeight: (isMobile ? 0 : 200),
        nudgeWidth: 0,
      }"
      @click="openMobileDialog"
    >
      <template v-slot:selection="{attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="item.color"
          :input-value="selected"
          label
          small
          class="px-1 mb-1 mt-1"
        >
          <span class="pr-2 white--text">
            {{ item.text }}
          </span>
          <v-icon
            small
            color="white"
            @click="parent.selectItem(item)"
          >
            mdi-close
          </v-icon>
        </v-chip>
      </template>
    </v-autocomplete>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="mobileDialog"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar
          fixed
          color="primary"
          elevation="4"
          class="px-3"
        >
          <v-app-bar-nav-icon>
            <v-btn
              icon
              dark
              @click="mobileDialog = false"
            >
              <v-icon
                color="white"
                style="font-size: 20px"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-app-bar-nav-icon>

          <v-toolbar-title style="color: white">
            {{ $t('tag') }}
          </v-toolbar-title>

          <v-spacer />
          <template v-slot:extension>
            <div
              style="width: 100%;margin-top: -40px"
            >
              <v-combobox
                ref="comboMobile"
                v-model="mobileModel"
                :items="mobileItems"
                :search-input.sync="mobileSearch"
                hide-selected
                hide-details
                :placeholder="$t('search')"
                :menu-props="{maxHeight: (isMobile ? 0 : 200)}"
                multiple
                outlined
                dense
                height="45"
                small-chips
                background-color="white"
              >
                <template v-slot:selection="{attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :color="item.color"
                    :input-value="selected"
                    label
                    small
                    class="px-1 mb-1 mt-1"
                  >
                    <span class="pr-2 white--text">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      color="white"
                      @click="parent.selectItem(item)"
                    >
                      mdi-close
                    </v-icon>
                  </v-chip>
                </template>
              </v-combobox>
              <!--              <v-text-field-->
              <!--                v-model="mobileSearch"-->
              <!--                :label="$t('search')"-->
              <!--                solo-->
              <!--                flat-->
              <!--                :loading="isLoading"-->
              <!--                height="45"-->
              <!--                clearable-->
              <!--              >-->
              <!--                <template v-slot:append>-->
              <!--                  <v-fade-transition leave-absolute>-->
              <!--                    <v-progress-circular-->
              <!--                      v-if="isLoading"-->
              <!--                      size="24"-->
              <!--                      color="green"-->
              <!--                      indeterminate-->
              <!--                    />-->
              <!--                  </v-fade-transition>-->
              <!--                </template>-->
              <!--              </v-text-field>-->
            </div>
          </template>
        </v-app-bar>
        <v-list style="margin-top: 98px">
          <!--          <v-subheader>REPORTS</v-subheader>-->
          <v-list-item-group
            v-model="mobileModel"
            color="primary"
            style="overflow-y: scroll;overflow-x: hidden;min-height: 400px;"
            multiple
          >
            <v-list-item
              v-for="(item, index) in mobileItems"
              :key="index"
              :value="item"
              class="data-table-list-items px-0"
              :class="{
                'mobile-td-list-border-primary': (!item.remain || item.remain && item.remain.remain == 0 ? true : false ),
                'mobile-td-list-border-red': (item.remain && item.remain.remain > 0 ? true : false ),
                'mobile-td-list-border-green': (item.remain && item.remain.remain < 0 ? true : false ),
              }"
              elevation="4"
            >
              <v-list-item-icon class="ps-2 me-1">
                <p class="mt-1">
                  {{ +index + +1 }}
                </p>
              </v-list-item-icon>
              <v-list-item-content class="ms-3">
                <v-list-item-title class="text-wrap">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                class="d-inline"
                @click.stop
              >
                <v-btn
                  icon
                  @click.stop.prevent="edit(index, item)"
                >
                  <v-icon
                    style="font-size: 26px"
                    color="grey"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop.prevent="openStop(item)"
                >
                  <v-icon
                    style="font-size: 26px"
                    color="pink"
                  >
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="justify-center">
              <div
                v-if="mobileItems && mobileItems.length !== 0 && last_page > 1 && last_page > page"
                v-observe-visibility="{
                  callback: visibilityChanged
                }"
                width="100%"
                height="40px"
                class="d-flex my-0 pa-2"
              >
                <v-progress-circular
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="dialog"
      width="300"
    >
      <v-card
        v-if="editing"
        class="pl-4"
      >
        <v-col>
          <v-color-picker
            v-model="editingColor"
            dot-size="25"
            hide-canvas
            hide-inputs
            hide-mode-switch
            hide-sliders
            mode="hexa"
            show-swatches
            swatches-max-height="132"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <v-text-field
            v-model="editingText"
            filled
            dense
            autofocus
            flat
            @keydown="keydown($event)"
          />
        </v-col>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="submit"
          >
            {{ $t('edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="stop"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            color="grey darken-2"
            class="close-hover"
            @click="stop = false"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('alert-delete-tag') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="stop = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import General from '@/Mixins/general'
  export default {
    mixins: [General],
    props: ['type', 'input', 'solo', 'height'],
    data: () => ({
      activator: null,
      attach: null,
      deleteItem: null,
      stop: false,
      formHasErrors: false,
      dialog: false,
      colors: ['green', 'red', 'blue', 'purple', 'pink', 'orange', 'deep-purple', 'teal', 'cyan', 'indigo', 'orange', 'amber', 'brown', 'deep-orange', 'grey', 'blue-grey'],
      editing: null,
      editingText: null,
      oldText: null,
      editingColor: null,
      editingIndex: -1,
      errorMessages: '',
      items: [
        { header: 'Select an option or create one' },
      ],
      nonce: 1,
      mobileDialog: false,
      timer: null,
      mobileSearch: null,
      mobileModel: null,
      last_page: null,
      page: 1,
      mobileItems: [],
      menu: false,
      model: [],
      x: 0,
      search: null,
      y: 0,
    }),
    watch: {
      model (val, prev) {
        if (val) {
          if (val.length === prev.length) {
            this.$emit('input', val)
            return
          }
          this.model = val.map(v => {
            if (typeof v === 'string') {
              v = {
                text: v,
                color: this.colors[this.nonce - 1],
                type: this.type,
                ref_id: null,
              }

              this.items.push(v)
              this.create(v)
              this.nonce++
            }
            this.$emit('input', this.model)
            return v
          })
        }
      },
      input (val, oldVal) {
        if (this.input) {
          if (this.isMobile) {
            this.mobileModel = this.input
          } else {
            this.model = this.input
          }
        } else {
          if (this.isMobile) {
            this.mobileModel = []
          } else {
            this.model = []
          }
        }
      },
      mobileSearch () {
        this.page = 1
        this.setInitial = false
        this.items = []
        this.mobileItems = []
        this.getItems()
      },
      mobileModel (val) {
        this.$emit('input', val)
        // this.model = this.mobileDialog
      },
    },
    mounted () {
      this.getItems()
      if (this.input) {
        if (this.isMobile) {
          this.mobileModel = this.input
        } else {
          this.model = this.input
        }
      }
    },
    methods: {
      visibilityChanged (e) {
        e && this.getItems()
      },
      openMobileDialog () {
        if (this.isMobile) {
          this.mobileDialog = true
          if (this.page === 1 && this.mobileItems.length === 0) {
            this.getItems()
          }
        }
      },
      create (item) {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'tags', {
          text: item.text,
          color: item.color,
          type: item.type,
          ref_id: item.ref_id,
        })
          .then(res => {
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      getItems () {
        var app = this
        app.isLoading = true
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'tags/show', {
            params: {
              search: (app.isMobile ? app.mobileSearch : null),
            },
          })
            .then(res => {
              if (!app.isMobile) {
                app.items = [
                  ...app.items,
                  ...Array.from(res.data.data),
                ]
              } else {
                app.mobileItems = [
                  ...app.mobileItems,
                  ...Array.from(res.data.data),
                ]
              }
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(function () {
              app.isLoading = false
              app.loading = false
            })
        }, 1000)
      },
      keydown: function (event) {
        switch (event.keyCode) {
          case 13:
            this.submit()
            break
        }
      },
      submit () {
        var index
        if (!this.isMobile) {
          index = this.items.findIndex(x => x.text === this.oldText)
          this.items[index].text = this.editingText
          this.items[index].color = this.editingColor
        } else {
          index = this.mobileItems.findIndex(x => x.text === this.oldText)
          this.mobileItems[index].text = this.editingText
          this.mobileItems[index].color = this.editingColor
        }
        this.dialog = false
        var app = this
        app.$axios.get(this.$endpoint + 'tags/' + this.editingText + '/edit', {
          params: {
            oldText: app.oldText,
            text: this.editingText,
            color: this.editingColor,
          },
        })
          .then(res => {
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      edit (index, item) {
        this.editing = item
        this.editingIndex = index
        this.editingText = item.text
        this.editingColor = item.color
        this.oldText = item.text
        this.dialog = true
      },
      openStop (item) {
        this.deleteItem = item
        this.stop = true
      },
      remove () {
        var index
        if (!this.isMobile) {
          index = this.items.findIndex(x => x.text === this.deleteItem.text)
          this.items.splice(index, 1)
        } else {
          index = this.mobileItems.findIndex(x => x.text === this.deleteItem.text)
          this.mobileItems.splice(index, 1)
        }
        this.stop = false
        var app = this
        app.$axios.delete(this.$endpoint + 'tags/' + this.deleteItem.text)
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      filter (item, queryText, itemText) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>
